package eu.codlab.navigation

import androidx.navigation.NavType
import androidx.savedstate.SavedState
import androidx.savedstate.read
import androidx.savedstate.write
import kotlinx.serialization.DeserializationStrategy
import kotlinx.serialization.KSerializer
import kotlinx.serialization.json.Json

class NavTypeWrapper<T>(
    private val serializer: KSerializer<T>,
    private val deserialize: DeserializationStrategy<T>
) {
    val navType = object : NavType<T>(
        isNullableAllowed = false
    ) {
        private val json = Json

        override fun put(
            bundle: SavedState,
            key: String,
            value: T
        ) {
            bundle.write {
                this.putString(key, json.encodeToString(serializer, value))
            }
        }

        override fun get(
            bundle: SavedState,
            key: String
        ) = bundle.read { parseValue(this.getString(key)) }

        override fun parseValue(value: String) = json.decodeFromString(deserialize, value)
    }
}
